import { render } from "./ThumbnailsCollectionIcon.vue?vue&type=template&id=12d95e9a"
const script = {}
script.render = render

export default script